import HeaderModal from "../../headers/header_modal";
import {Container, Content, ContentItem} from "./styled";
import React from "react";
import {ModalPriorityProps, PriorityType} from "@dropDesk/presentation/components/modals/modal_priority/modal_priority";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import ModalMain from "@dropDesk/presentation/components/modals/modal_main";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";


export default function ModalPriority(props: ModalPriorityProps) {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <ModalMain
            open={props.visible}
            onRequestClose={props.onClose}
            width={600}
            renderComponent={
                <Container background={colors.onBackground}>
                    <HeaderModal
                        disabled={props.loading}
                        letter={"Selecione a prioridade"}
                        nameIcon={ICONS_DROPDESK.close}
                        onClick={props.onClose}
                    />
                    <Content>

                        {props.listPriority.map((priority) => {
                            return (
                                <ContentItem
                                    key={priority.value}
                                    disabled={props.loading}
                                    color={colors.text}
                                    border={colors.border}
                                    accent={colors.accent}
                                    background={colors.onBackground}
                                    onClick={() => {
                                        props.onSelectPriority(priority);
                                    }
                                    }
                                >
                                    {priority.label}
                                </ContentItem>
                            );
                        })}
                    </Content>
                </Container>}
        />
    );
}
